import React, { useState } from "react";
import "../Buttons/Buttons.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  RESET_SALES_REP_CLASSIFICATION,
  RESET_BASIC_DETAILS,
  RESET_POWER_POSITION,
  CREATE_NEGOTIATION,
  RESET_TARGET_VALUE_DETAILS,
  RESET_SELECTED_ACTION_TILES,
} from "../../redux/Action/actionTypes";
import ModalComponent from "../Modal/modal";

interface ButtonsProps {
  isLastStep?: boolean;
  currentStep: number;
  totalSteps: number;
  goNext: () => void;
  goBack: () => void;
  isNextDisabled: boolean;
  isSkipSalesRep?: boolean;
  skipHandler?: (data: boolean) => void;
  setIsSkipSalesRep?: React.Dispatch<React.SetStateAction<boolean>>;
  isShowClassification?: boolean;
  setIsShowClassification?: React.Dispatch<React.SetStateAction<boolean>>;
  submitHandler?: () => void;
  isSubmitDisabled?: boolean;
  saveHandler?: () => void;
}

const Buttons = ({
  currentStep,
  totalSteps,
  goNext,
  goBack,
  isLastStep,
  isNextDisabled,
  saveHandler,
  skipHandler = () => { },
  isSkipSalesRep = false,
  setIsSkipSalesRep = () => { },
  isShowClassification = false,
  setIsShowClassification = () => { },
  submitHandler = () => { },
  isSubmitDisabled = false,
}: ButtonsProps) => {
  const [isExitClick, setIsExitClick] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const skipPopupBodyMessage = (
    <>
      <p>You have not selected any sales rep's negotiation type.</p>
      <p>
        Do you want to proceed and classify the type at a later stage(e.g. after
        the first meeting with the sales rep)?
      </p>
    </>
  );

  const exitConfirmHandler = () => {
    dispatch({ type: RESET_BASIC_DETAILS });
    dispatch({ type: RESET_POWER_POSITION });
    dispatch({ type: RESET_SALES_REP_CLASSIFICATION });
    dispatch({ type: RESET_TARGET_VALUE_DETAILS });
    dispatch({ type: RESET_SELECTED_ACTION_TILES });
    dispatch({ type: CREATE_NEGOTIATION });
    dispatch({ type: RESET_TARGET_VALUE_DETAILS });
    setIsExitClick(false);
    navigate("/");
  };

  const exitPopUpHandler = () => {
    setIsExitClick(!isExitClick);
  };

  const cancelBtnHandler = () => {
    setIsExitClick(false);
  };

  const skipCancelHandler = () => {
    setIsSkipSalesRep(false);
  };

  let button;
  if (isShowClassification) {
    button = <button
      className="stepper-button continue-button"
      onClick={submitHandler}
      disabled={isSubmitDisabled}
    >
      Submit
    </button>
  }
  else if (isLastStep) {
    button = <button
      className="finalization-button"
      onClick={goNext}
      disabled={isNextDisabled}
    >
      Finish negotiation setup
    </button>
  }
  else {
    button = <button
      className="stepper-button continue-button"
      onClick={currentStep === 2 ? () => skipHandler(false) : goNext}
      disabled={isNextDisabled}
    >
      Continue
    </button>
  }
  return (
    <>
      <div className="stepper-buttons-wrapper">
        <div className="save-Exit-buttons">
          <button className="Exit-button" onClick={exitPopUpHandler}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M5.44983 19.0502L18.5503 5.94971M5.44983 5.94971L18.5503 19.0502"
                stroke="#C50022"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="exit-text">Exit</div>
          </button>
          <button className="save-button" type="button" onClick={saveHandler}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="save-icon"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 18 18"
            >
              <path d="M11 2H9v3h2z" />
              <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z" />
            </svg>
            <div className="save-text">Save As Draft</div>
          </button>
        </div>
        <div className="back-continue-buttons">
          {currentStep !== 0 && (
            <button
              className="stepper-button back-button"
              onClick={
                isShowClassification
                  ? () => setIsShowClassification(false)
                  : goBack
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 30 30"
                fill="none"
                className="back-icon"
              >
                <path
                  d="M11 21L2 12L11 3"
                  stroke="#004A96"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Back
            </button>
          )}
          {button}
        </div>
      </div>
      {isExitClick && (
        <ModalComponent
          isOpen={isExitClick}
          modalTitle={"Confirmation"}
          toggle={cancelBtnHandler}
          modalBody="Are you sure you want to exit without saving?"
          btnLeftHandler={exitConfirmHandler}
          btnLeftLabel={"Yes"}
          btnRightLabel={"No"}
        />
      )}
      {isSkipSalesRep && (
        <ModalComponent
          isOpen={isSkipSalesRep}
          modalTitle={"Warning"}
          toggle={skipCancelHandler}
          modalBody={skipPopupBodyMessage}
          btnLeftHandler={() => skipHandler(true)}
          btnLeftLabel={"Yes"}
          btnRightLabel={"No"}
        />
      )}
    </>
  );
};

export default Buttons;
